import { render } from "./StyleGuideButton.vue?vue&type=template&id=ed7f90c2&scoped=true"
import script from "./StyleGuideButton.vue?vue&type=script&lang=js"
export * from "./StyleGuideButton.vue?vue&type=script&lang=js"

import "./StyleGuideButton.vue?vue&type=style&index=0&id=ed7f90c2&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/kama-dugri/kama-dugri/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed7f90c2"]])

export default __exports__